import axios, {AxiosPromise} from 'axios';
import {IGetLandingDatabases, ILandingDatabaseParams} from '../models/landingDatabase.model';
import QueryString from 'qs';

const uri = '/mgmt/landing/database';

export const getLandingDatabases = (params: ILandingDatabaseParams): AxiosPromise<IGetLandingDatabases> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}?${qsParams}`);
};



